export const EMPLOYMENT_TYPE = {
  FULL_TIME: getText('Full Time Employee'),
  PART_TIME: getText('Part Time Employee'),
  TEMPORARY: getText('Temporary'),
  CONTRACT: getText('Contract/Freelance'),
};
